export default "__VITE_ASSET__DsyOdYrL__"